module.exports = __webpack_public_path__ + "img/plusFunnel.a476bfe4.svg";